










































































import { Component, Prop, Vue } from 'vue-property-decorator';


@Component({
  components: {
  },
})
export default class ChartCard extends Vue {

  @Prop({ type: String, default: '标题'})
  private title!: string;

  @Prop({ type: String, default: '总量'})
  private total!: string;

}
